import { render, staticRenderFns } from "./questionsList.vue?vue&type=template&id=1b3a1a7c&scoped=true"
import script from "./questionsList.vue?vue&type=script&lang=js"
export * from "./questionsList.vue?vue&type=script&lang=js"
import style0 from "./questionsList.vue?vue&type=style&index=0&id=1b3a1a7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3a1a7c",
  null
  
)

export default component.exports